import axios from 'axios'
import session from 'vue-cookies'
var url = "https://api.bertiebets.com/tasks"
var key = session.get('bertiebets.admin.key')
export function getTasks() {
  return new Promise ((resolve, reject) => {
    axios
    .get(url, {headers:{'x-api-key' : key}})
    .then(response => {
      if (response.status === 200) {
        resolve(response.data)
      }else {
        reject(response.status)
      }
    })
    .catch (err => {
      reject(err)
    })
  })
}

export function triggerTraining(datasetNumber, password) {
  return new Promise ((resolve, reject) => {
    var body = {
      type: "train",
      datasetNumber: datasetNumber,
      source: "bertiebets.com"
    }
    axios
    .post(url,body, {headers:{'x-api-key' : key, password: password}})
    .then(response => {
      console.log(response)
      if (response.status === 200 || response.status === 202) {
        resolve(response.data)
      }else {
        reject(response)
      }
    })
    .catch (err => {
      reject(err)
    })
  })
}

export async function triggerEvaluation(datasetNumber, predictionConfigId, password) {
    var body = {
      type: "evaluate",
      number: datasetNumber,
      name: 'main',
      predictionConfigId: predictionConfigId,
      source: "bertiebets.com"
    }
    console.log(datasetNumber)
    console.log(body)
    var response = await axios.post(url,body, {headers:{'x-api-key' : key, password: password}})
    if (response.status === 200 || response.status === 202) {
      return response.data
    }else {
      throw err
    }
}
